import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import FixedContainer from './FixedContainer';
import ClientProvider from './client';
export default createDemo(import.meta.url, FixedContainer, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/container/demos/fixed/FixedContainer.tsx",
    "fileName": "FixedContainer.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport CssBaseline from '@mui/material/CssBaseline';\nimport Box from '@mui/material/Box';\nimport Container from '@mui/material/Container';\n\nexport default function FixedContainer() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <React.Fragment>\n      <CssBaseline />\n      <Container fixed>\n        <Box sx={{ bgcolor: '#cfe8fc', height: '100vh' }} />\n      </Container>\n    </React.Fragment>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 15,
        "focusedLines": 6,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport CssBaseline from '@mui/material/CssBaseline';\nimport Box from '@mui/material/Box';\nimport Container from '@mui/material/Container';\n\nexport default function FixedContainer() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <React.Fragment>\n      <CssBaseline />\n      <Container fixed>\n        <Box sx={{ bgcolor: '#cfe8fc', height: '100vh' }} />\n      </Container>\n    </React.Fragment>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 8
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "React.Fragment"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 9
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "CssBaseline"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 10
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Container"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "fixed"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 11
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "bgcolor"
              ],
              ": ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "#cfe8fc",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "height"
              ],
              ": ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "100vh",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 12
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Container"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 13
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "React.Fragment"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 15,
    "focusedLines": 6,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/CssBaseline",
      "@mui/material/Box",
      "@mui/material/Container"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
